<template>
  <div class="bg-white">
    <p v-if="isDev" class="p-2 font-medium-3 font-weight-bold">
      Đây là môi trường phát triển vui lòng vào môi trường chính thức
      <a href="https://vc.itel.vn/videoCall/QuanLyDTV">Tại đây!</a>
    </p>
    <div class="wrap-content">
      <div class="d-flex w-100">
        <b-col lg="4" class="d-flex  align-items-baseline ">
          <h4 class="mr-2">Số thuê bao</h4>
          <b-form-input
            type="text"
            class="w-75"
            placeholder="087..."
            v-model="phone"
            @input="ResetMessage"
          ></b-form-input>
        </b-col>
        <b-col lg="4" class="d-flex  align-items-baseline">
          <h4 class="mr-2">Số liên hệ</h4>
          <b-form-input
            type="text"
            class="w-75"
            placeholder="08..."
            v-model="contactPhone"
            @input="ResetMessage"
          ></b-form-input>
        </b-col>
      </div>
      <p
        class="font-medium-2"
        :class="isFalse ? 'text-danger' : 'text-success'"
        v-html="statusMessage"
      ></p>
      <div class="d-flex justify-content-end align-items-baseline mt-2">
        <button class="btn btn-primary px-4 mr-2" @click="CheckStatusNumber">
          Kiểm tra
        </button>
        <button
          class="btn btn-primary px-4"
          @click="sendOTP"
          :disabled="isFalse"
        >
          Gửi OTP
        </button>
      </div>
      <div class="mt-4">
        <h4>Link cập nhật</h4>
        <div class="d-flex">
          <b-form-input
            type="text"
            class="w-75 bg-white"
            placeholder="Link"
            ref="videoLink"
            readonly
          ></b-form-input>
          <button class="btn btn-primary w-25" @click="copyCode">
            Copy Link
          </button>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-otp"
      size="lg"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      centered
      hide-header
    >
      <template>
        <div class="incoming-call-container">
          <div
            class="text-center text-primary font-large-1 font-weight-bold mb-2"
          >
            Thông báo
          </div>
          <div class="font-medium-2" style="color: black">
            <p class="text-center">
              Hệ thống đã gửi OTP đến số thuê bao {{ phone }}
            </p>
            <!--            <p class="text-center">Mã OTP: {{otpRegister}}</p>-->
            <div class="d-flex justify-content-center">
              <OtpInput
                ref="otpInput"
                separator=""
                input-classes="otp-input"
                :num-inputs="4"
                @on-change="handleOnChange"
              />
            </div>
          </div>
          <div class="d-flex justify-content-around mt-3">
            <button class="btn btn-primary col-3 " @click="createLink">
              Tạo link
            </button>
            <button class="btn btn-secondary col-3" @click="closeModalOTP">
              Quay lại
            </button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BCol, BFormInput } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import { $ctx } from "@themeConfig";
import OtpInput from "@bachdgvn/vue-otp-input";
import axios from "axios";

export default {
  name: "VideoCallCNTT",
  components: {
    BFormInput,
    BCol,
    OtpInput
  },
  data() {
    return {
      phone: "",
      statusMessage: "",
      isFalse: true,
      contactPhone: "",
      otpUpdate: "",
      otpSend: "",
      URL_WEB_API: $ctx.API_URL.includes("dev")
        ? "https://itel.dev"
        : "https://itel.vn",
      isDev: $ctx.API_URL.includes("dev"),
      roomType:Math.random() < 0.5 ? 83 : 86
    };
  },
  methods: {
    handleOnChange(otp) {
      console.log(otp);
      this.otpUpdate = otp;
    },
    closeModalOTP() {
      this.$bvModal.hide("modal-otp");
    },
    showLoading(options) {
      document.getElementById("loading-bg").style.display = options;
    },
    copyCode() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Copy code thành công!",
          icon: "CheckSquareIcon",
          variant: "success"
        }
      });
      navigator.clipboard.writeText(this.$refs.videoLink.value);
    },
    CheckStatusNumber() {
      this.showLoading("block");
      if (this.phone.length !== 10) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Số thuê bao bắt đầu bằng số 0 và có 10 chữ số",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
        this.showLoading("none");
        return;
      }
      if (this.contactPhone.length !== 10) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Số liên hệ bắt đầu bằng số 0 và có 10 chữ số",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
        this.showLoading("none");
        return;
      }
      axios
        .get(this.URL_WEB_API + "/api/web/check_sub_registration/" + this.phone)
        .then(res => {
          this.showLoading("none");
          if (res.data.code === 200) {
            this.statusMessage = res.data.message;
            this.isFalse = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: res.data.message,
                icon: "CheckSquareIcon",
                variant: "success"
              }
            });
          } else {
            this.statusMessage = res.data.message;
            this.isFalse = true;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: res.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            });
          }
        })
        .catch(err => {
          this.showLoading("none");
          this.statusMessage = err.response.data.message;
          this.isFalse = true;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: err.response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger"
            }
          });
        });
    },
    createLink() {
      useJwt
        .get("check-otp-dktt-update/" + this.phone + "/" + this.otpUpdate)
        .then(res => {
          if (res.data.code === 200) {
            this.$bvModal.hide("modal-otp");
            // const key = (parseInt(this.phone.slice(-3)) + 112) * 2;
            // const room=this.roomType===83?86:83
            const room=83
            this.roomType= room
            const key = Date.parse(new Date()) + parseInt(this.phone)*2 + 112;
            // if (Math.random() < 0.5) {
              this.$refs.videoLink.value =
                 this.URL_WEB_API +
                  "/CNTT/" +
                  this.phone +
                  "/" +
                  this.contactPhone +
                  "/" +
                  key+"/"+room;
            // } else {
            //   this.$refs.videoLink.value =
            //       this.URL_WEB_API +
            //       "/CNTT/" +
            //       this.phone +
            //       "/" +
            //       this.contactPhone +
            //       "/" +
            //       key+"/86";
            // }

          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Mã OTP không đúng!",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            });
          }
        })
        .catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Có lỗi xảy ra vui lòng thử lại!",
              icon: "AlertTriangleIcon",
              variant: "danger"
            }
          });
        });
    },
    ResetMessage() {
      this.statusMessage = "";
      this.$refs.videoLink.value = "";
    },
    sendOTP() {
      this.loading(true);
      useJwt
        .get("send-otp-dktt-update/" + this.phone)
        .then(res => {
          this.loading(false);
          this.$bvModal.show("modal-otp");
          this.otpSend = res.data.result;
        })
        .catch(err => {
          console.log(err);
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Gửi OTP thất bại!",
              icon: "AlertTriangleIcon",
              variant: "warning"
            }
          });
        });
    }
  }
};
</script>

<style scoped lang="scss">
.wrap-content {
  padding: 3rem 4rem 3rem 2rem;
}
</style>
<style lang="scss">
.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;

  &.error {
    border: 1px solid red !important;
  }
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
